<template>
    <div id="layout">
        <Menu></Menu>
        <div id="content">
            <div class="side">
                <tools-side-menu></tools-side-menu>
            </div>
            <keep-alive>
                <router-view></router-view>
            </keep-alive>
        </div>
    </div>
</template>

<script>
    import Menu from '@/components/small/Menu'
    import ToolsSideMenu from "@/components/small/ToolsSideMenu";

    export default {
        name: "Tools",
        components:{
            ToolsSideMenu,
            Menu
        }
    }
</script>

<style scoped>
    #content{
        flex-wrap: wrap;
    }

    .side{
        width: unset;
        border-right: none;
        border-bottom: none;
    }

    .page-content{
        height: 100%;
        flex: 4 80%;
        flex-direction: row;
        flex-wrap: wrap;
        padding: 0.5rem;
        overflow-y: auto;
        align-content: start;
    }
</style>
